module.exports = __webpack_public_path__ + "img/logo-branding.f80d8ae6.svg";